/**
 * Phase 15 D-FETCH-01 — in-memory ETag cache. The fetcher reads a cached
 * ETag for an URL and sends it as If-None-Match; on 304 it returns the
 * cached body. On 200 it stores the new ETag + body. Cache lives in module
 * scope (per-tab); cleared on full reload. No persistence (the cache key
 * includes the URL with querystring, so polling-window churn is rapid).
 */
interface CacheEntry<T = unknown> {
  etag: string;
  body: T;
  stored_at: number;
}

const cache = new Map<string, CacheEntry>();

export function getEtag(url: string): string | undefined {
  return cache.get(url)?.etag;
}

export function getBody<T = unknown>(url: string): T | undefined {
  return cache.get(url)?.body as T | undefined;
}

export function store<T = unknown>(url: string, etag: string, body: T): void {
  cache.set(url, { etag, body, stored_at: Date.now() });
}

/** Test/cleanup helper -- not used in production. */
export function clear(): void {
  cache.clear();
}
